import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Story } from '@jaimo-solutions-gmbh/platform-services-module';
import { openConsent } from 'src/helpers';

@Component({
  selector: 'app-story',
  templateUrl: './story.component.html',
  styleUrls: ['./story.component.scss'],
})
export class StoryComponent implements OnInit {
  @ViewChild('storyContainer') storyContainer: ElementRef;
  @Input() story: Story & {
    duration?: number;
    file: HTMLVideoElement | HTMLImageElement;
  };
  @Input() active: boolean;
  @Input() muted: boolean;
  @Input() isFirst: boolean;

  @Output() onNext = new EventEmitter<{ muted: boolean }>();
  @Output() onPrev = new EventEmitter<{ muted: boolean }>();
  @Output() onStart = new EventEmitter();

  media: HTMLVideoElement | HTMLImageElement;

  muteToggled = false;
  constructor(private modalCtrl: ModalController) {}

  ngOnInit(): void {
    this.media = this.story.file.cloneNode() as
      | HTMLVideoElement
      | HTMLImageElement;
  }

  ngOnChanges() {
    const waitForMedia = setInterval(() => {
      if (this.media) {
        window.clearInterval(waitForMedia);
        const videoElement =
          this.story.attachment.mimeType === 1 &&
          (this.media as HTMLVideoElement);

        if (this.active && videoElement) {
          this.addPlayListener(videoElement);
          videoElement.currentTime = 0;
          videoElement.muted = this.muted;
          videoElement.play().then(() => {
            this.muteToggled = false;
          });
        } else if (this.story.attachment.mimeType === 2 && this.active) {
          this.onStart.emit();
        }
      }
    }, 50);
  }

  openConsent() {
    if (this.media instanceof HTMLVideoElement) this.media.pause();
    openConsent(
      this.story.source.sourceOrigin,
      this.story.source.platform,
      this.modalCtrl
    );
  }

  ngAfterViewInit() {
    this.storyContainer?.nativeElement.appendChild(this.media);
    const videoElement =
      this.story.attachment.mimeType === 1 && (this.media as HTMLVideoElement);
    if (this.story.attachment.mimeType === 2 && this.active) {
      this.onStart.emit();
    }

    this.media.addEventListener('click', (e) => {
      e.stopPropagation();
      this.muteToggled = true;
      setTimeout(() => {
        this.muteToggled = false;
      }, 1000);
      this.toggleMute();
    });

    if (videoElement) {
      videoElement.addEventListener('touchstart', () => {
        videoElement.pause();
      });
      videoElement.addEventListener('mousedown', () => {
        videoElement.pause();
      });
      videoElement.addEventListener('touchend', () => {
        videoElement.play();
      });
      videoElement.addEventListener('click', () => {
        videoElement.play();
      });
    }
  }

  addPlayListener(videoElement) {
    const wait = setInterval(() => {
      const time = videoElement.currentTime;
      if (time > 0) {
        this.onStart.emit();
        window.clearInterval(wait);
      }
    });
  }

  toggleMute() {
    this.muted = !(this.media as HTMLVideoElement).muted;
    (this.media as HTMLVideoElement).muted = this.muted;
  }

  next(event) {
    event.stopPropagation();
    if (this.story.attachment.mimeType === 1) {
      (this.media as HTMLVideoElement).pause();
      (this.media as HTMLVideoElement).currentTime = 0;
    }
    this.onNext.emit({ muted: this.muted });
  }

  prev(event) {
    event.stopPropagation();
    if (this.story.attachment.mimeType === 1) {
      !this.isFirst && (this.media as HTMLVideoElement).pause();
      (this.media as HTMLVideoElement).currentTime = 0;
      this.addPlayListener(this.media);
    }
    this.onPrev.emit({ muted: this.muted });
    if (this.isFirst) {
      setTimeout(() => {
        this.onStart.emit();
      }, 50);
    }
  }

  isDesktop() {
    return window.innerWidth >= 992;
  }
}
